import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "@clearabee/i18n";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources: {
    en: {
      translation: translations?.en ?? {},
    },
  },
  returnObjects: true,
});

export default i18n;
